export default __webpack_public_path__ + "static/media/gallery_06.ce182a12.jpg";